export const suffixMessageTags = {
  de: {
    name: 'einen',
    firstname: 'einen',
    lastname: 'einen',
    username: 'eine',
    password: 'ein',
    password_confirmation: 'ein',
    organization: 'eine',
    code: 'einen',
    organization_address: 'eine',
    organization_address2: 'eine',
    organization_city: 'einen',
    organization_zip: 'eine',
    organization_phone: 'eine',
    organization_mail: 'eine',
    organization_website: 'eine',
    salutation: 'eine',
    slug: 'einen',
    nickname: 'einen',
    title: 'einen',
    email: 'eine',
    zip: 'eine',
    city: 'einen',
    address: 'eine',
    token: 'einen',
  },
  fr: {
    name: 'un',
    firstname: 'un',
    lastname: 'un',
    password: 'un',
    username: 'une',
    email: 'une',
    code: 'un',
    organization: 'une',
    organization_address: 'une',
    organization_address2: 'un',
    organization_city: 'une',
    organization_zip: 'un',
    organization_phone: 'un',
    organization_mail: 'une',
    organization_website: 'une',
    salutation: 'une',
    slug: 'un',
    zip: 'un',
    city: 'une',
    title: 'un',
    address: 'une',
    token: 'un',
  },
  it: {
    name: 'un',
    firstname: 'un',
    lastname: 'un',
    password: 'una',
    password_confirmation: 'una',
    username: 'un',
    email: 'un',
    code: 'un',
    organization: "un'",
    organization_address: 'un',
    organization_zip: 'un',
    organization_city: 'una',
    organization_mail: 'un',
    organization_phone: 'un',
    organization_website: 'un',
    salutation: 'un',
    slug: 'uno',
    zip: 'un',
    city: 'una',
    title: 'un',
    address: 'un',
    token: 'un',
  },
  rm: {
    name: 'einen',
    firstname: 'einen',
    lastname: 'einen',
    username: 'eine',
    password: 'ein',
    password_confirmation: 'ein',
    organization: 'eine',
    code: 'einen',
    organization_address: 'eine',
    organization_address2: 'eine',
    organization_city: 'einen',
    organization_zip: 'eine',
    organization_phone: 'eine',
    organization_mail: 'eine',
    organization_website: 'eine',
    salutation: 'eine',
    slug: 'einen',
    nickname: 'einen',
    title: 'einen',
    email: 'eine',
    zip: 'eine',
    city: 'einen',
    address: 'eine',
    token: 'einen',
  },
  en: {
    name: 'a',
    firstname: 'a',
    lastname: 'a',
    username: 'a',
    password: 'a',
    password_confirmation: 'a',
    organization: 'an',
    code: 'a',
    organization_address: 'an',
    organization_address2: 'an',
    organization_city: 'an',
    organization_zip: 'an',
    organization_phone: 'an',
    organization_mail: 'an',
    organization_website: 'an',
    salutation: 'a',
    slug: 'a',
    nickname: 'a',
    title: 'a',
    email: 'an',
    zip: 'a',
    city: 'a',
    address: 'an',
    token: 'a',
  },
};
